// POR QUE NO SALIO LO QUE LE PEDISTE A LA IA, DICHO PARA UNA PERSONA.
//
// Crismar Perez, 2026-09-17: *"No se pudo traducir: Azure OpenAI returned no
// content"*. Esa frase es de la tripa del servidor: no dice qué pasó ni qué
// hacer, así que quien la lee sólo puede volver a pulsar el botón.
//
// ── SE DECIDE POR EL CODIGO, NO POR EL TEXTO ───────────────────────────────
//
// El servidor manda un `code` legible por máquina (`TEXTO_DEMASIADO_LARGO`,
// `IA_SIN_RESPUESTA`). El texto del mensaje cambia el día que cambie la
// librería o el proveedor; el código no. Buscar dentro del mensaje sería el
// mismo error que ya costó una tarde en E-281 con el estatus migratorio:
// comparar por lo que se ve en vez de por la clave.
//
// Y un código que NO se reconoce enseña el mensaje crudo. Inventarse una
// explicación para un fallo desconocido es peor que enseñar el original: al
// original al menos se le puede buscar.
//
// ── POR QUE VIVE AQUI Y NO EN UNA PANTALLA ─────────────────────────────────
//
// Porque lo usan dos: el editor de plantillas de Firmas (traducir y convertir
// un documento) y el Asistente de IA (resumir, redactar, sugerir). Nació dentro
// de SignaturesView y la segunda pantalla habría copiado la función — que es
// exactamente como esta base de código acaba con dos versiones de lo mismo
// separándose sin que nadie lo note (la cabecera de `estatusMigratorio.js` lo
// cuenta con tres).

/**
 * @param {Error & {code?: string, serverCode?: string, caracteres?: number, maximo?: number}} err
 * @param {'es'|'en'} lang
 * @returns {string} la razón, para pegar detrás de "No se pudo X: "
 */
export function motivoDelFalloDeIA(err, lang) {
  const es = lang === 'es';
  const codigo = err && (err.code || err.serverCode);

  if (codigo === 'TEXTO_DEMASIADO_LARGO') {
    // Sin nombrar la acción: el aviso ya empieza por "No se pudo traducir",
    // "No se pudo convertir el documento" o "No se pudo resumir", así que la
    // misma frase sirve para las tres y no hay tres textos que mantener.
    const n = (x) => Number(x || 0).toLocaleString(es ? 'es-ES' : 'en-US');
    return es
      ? `es demasiado largo para hacerlo de una vez (tiene ${n(err.caracteres)} caracteres y el máximo son ${n(err.maximo)}). Pártelo en dos y repite la operación con cada mitad.`
      : `it is too long to do in one go (${n(err.caracteres)} characters, the maximum is ${n(err.maximo)}). Split it in two and repeat with each half.`;
  }

  if (codigo === 'IA_SIN_RESPUESTA') {
    return es
      ? 'el asistente devolvió una respuesta vacía. Vuelve a intentarlo; si se repite, el texto es demasiado largo o demasiado complejo para una sola pasada y conviene partirlo.'
      : 'the assistant came back empty. Try again; if it keeps happening the text is too long or too complex for one pass and is better split.';
  }

  return (err && err.message) || (es ? 'error' : 'error');
}
